import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';

function TrackingStatuses({ statuses = [], selectedState = [], setSelectedState = () => {}, type = '' }) {
  const [statusList, setStatusList] = useState(
    statuses.map((status) => {
      const obj = {
        CREATED_LABEL: { name: 'Etiqueta Creada', selected: selectedState.includes('CREATED_LABEL'), request: 'CREATED_LABEL' },
        ON_THE_WAY: { name: 'En Camino', selected: selectedState.includes('ON_THE_WAY'), request: 'ON_THE_WAY' },
        PROCESS_DELIVERY: { name: 'Proceso de Entrega', selected: selectedState.includes('PROCESS_DELIVERY'), request: 'PROCESS_DELIVERY' },
        DELIVERED: { name: 'Entregado', selected: selectedState.includes('DELIVERED'), request: 'DELIVERED' },
        EXCEPTION: { name: 'Excepcion', selected: selectedState.includes('EXCEPTION'), request: 'EXCEPTION' },
        UPDATED_DELIVERY: { name: 'Entrega Actualizada', selected: selectedState.includes('UPDATED_DELIVERY'), request: 'UPDATED_DELIVERY' },
        RETURNED: { name: 'Retornado', selected: selectedState.includes('RETURNED'), request: 'RETURNED' },
      };
      return obj[status];
    })
  );
  useEffect(() => {
    setSelectedState(statusList.filter((item) => item.selected).map((item) => item.request));
  }, [statusList]);

  return (
    <>
      <Form.Label>
        {' '}
        {`${type === 'internal' ? '1.' : '4.'} Selecciona los estados de seguimiento para los cuales deseas ${
          type === 'internal' ? 'recibir' : 'enviar'
        } notificaciones:`}
      </Form.Label>
      {statusList?.map((status, index) => (
        <div key={index} className="ms-2">
          <input
            type="checkbox"
            className="form-check-input me-2"
            checked={status.selected}
            onClick={() => {
              setStatusList(
                statusList.map((elem) => {
                  if (status.name === elem.name) {
                    elem.selected = !status.selected;
                  }
                  return elem;
                })
              );
              //   setErrors((prev) => {
              //     return { ...prev, deliveryType: '' };
              //   });
            }}
          />
          <label className="form-label">{status.name}</label>
        </div>
      ))}
    </>
  );
}

export default TrackingStatuses;
